import {useEffect, useState} from 'react'
import Sidebar from './components/Sidebar'
import LoginScreen from './components/LoginScreen'
import Ofp from './components/Ofp'
import Details from './components/Details'

function App(){
  const [username,setUsername] = useState(JSON.parse(localStorage.getItem('username')) || '');
  const [ofp,setOfp] = useState(null);
  const [showOfp, setShowOfp] = useState(false);

  useEffect( () => {
    document.title = "𝗬𝗼𝘂𝗿𝗘𝗙𝗕 𝗩𝟮"
    username && fetch(`https://www.simbrief.com/api/xml.fetcher.php?username=${username}&json=1`)
    .then(data => data.json())
    .then(data => {
      let status = data.fetch.status;
      if(status === "Success"){
        setOfp(JSON.stringify(data))
      }else{
        setUsername('')
      }
    })
   },[])

  return (
    <div className="h-full lg:h-screen sm:h-full lg:flex bg-black">
      <Sidebar {...{username,setUsername,showOfp, setShowOfp}} />


      {!username ? (<LoginScreen {...{username,setUsername,setOfp}}/>) : ofp != null && showOfp ? (<Ofp ofp={ofp} />) : ( <Details {...{ofp,username}} /> )}

    </div>
  );
}

export default App;
